import { render, staticRenderFns } from "./WatchlistDialog.vue?vue&type=template&id=2533f916&"
import script from "./WatchlistDialog.vue?vue&type=script&lang=js&"
export * from "./WatchlistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports